'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var SIDE_PADDING = 16;
var variantCellStyles = {
    header: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    font-weight: 500;\n    text-align: left;\n    color: ", ";\n  "], ["\n    font-weight: 500;\n    text-align: left;\n    color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyDark;
    }),
    none: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.fontColor;
    }),
};
var centerCellStyles = {
    1: styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    text-align: center;\n  "], ["\n    text-align: center;\n  "]))),
    0: styled.css(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    text-align: initial;\n  "], ["\n    text-align: initial;\n  "]))),
};
var StyledCell = styled__default.td(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  font: 14px/22px ", ";\n  padding: 12px 16px;\n  margin: 0 0 4px;\n  border-bottom: 1px solid ", ";\n  ", "\n  ", ";\n  font-weight: ", ";\n  display: ", ";\n\n  a {\n    text-decoration: none;\n    color: ", ";\n    &:hover {\n      color: ", ";\n    }\n  }\n"], ["\n  font: 14px/22px ", ";\n  padding: 12px 16px;\n  margin: 0 0 4px;\n  border-bottom: 1px solid ", ";\n  ", "\n  ", ";\n  font-weight: ", ";\n  display: ", ";\n\n  a {\n    text-decoration: none;\n    color: ", ";\n    &:hover {\n      color: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyMedium;
}, function (_a) {
    var _b = _a.center, center = _b === void 0 ? 0 : _b;
    return centerCellStyles[center];
}, function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'none' : _b;
    return variantCellStyles[variant];
}, function (_a) {
    var cellIndex = _a.cellIndex;
    return (cellIndex === 0 ? 500 : 'normal');
}, function (_a) {
    var hidden = _a.hidden;
    return (hidden ? 'none' : 'table-cell');
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primaryHover;
});
var StyledHeaderCell = styled__default.th(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  font: 14px/22px ", ";\n  padding: 12px ", "px;\n  margin: 0 0 4px;\n  border-bottom: 1px solid ", ";\n\n  ", ";\n  ", ";\n  display: ", ";\n"], ["\n  font: 14px/22px ", ";\n  padding: 12px ", "px;\n  margin: 0 0 4px;\n  border-bottom: 1px solid ", ";\n\n  ", ";\n  ", ";\n  display: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, SIDE_PADDING, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyMedium;
}, function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'none' : _b;
    return variantCellStyles[variant];
}, function (_a) {
    var _b = _a.center, center = _b === void 0 ? 0 : _b;
    return centerCellStyles[center];
}, function (_a) {
    var hidden = _a.hidden;
    return (hidden ? 'none' : 'table-cell');
});
var Cell = function (_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'none' : _b, _c = _a.center, center = _c === void 0 ? 0 : _c, cellIndex = _a.cellIndex, restCellProps = tslib_es6.__rest(_a, ["children", "variant", "center", "cellIndex"]);
    return (React__default.createElement(React__default.Fragment, null, variant === 'header'
        ? React__default.createElement(StyledHeaderCell, tslib_es6.__assign({ variant: variant, center: center }, restCellProps), children)
        : React__default.createElement(StyledCell, tslib_es6.__assign({ variant: variant, center: center, cellIndex: cellIndex }, restCellProps), children)));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

exports.Cell = Cell;
exports.SIDE_PADDING = SIDE_PADDING;
